<template>
  <div class="common-wrapper home-user-info-wrapper">
    <div
      class="home-user-info"
      :class="{ 'home-user-info--sticky': showSticky }"
      ref="homeUserInfo"
    >
      <template v-if="userinfo && userinfo.user_id">
        <UserInfo :showInfo="userinfo" :lang-text="!isCSSMobile" :key="isCSSMobile" />
        <div
          class="switch-user"
          v-if="loginType !== 'role_id' && loginType !== 'role_id_safe'"
          @click="toggleRole"
        ></div>
      </template>
      <div v-else class="no-login medium">
        {{ $t('text.loginFirst') }}&nbsp;
        <span class="login-btn" @click="login">{{ $t('text.login') }} ></span>
      </div>

      <transition name="transy">
        <HomeSticky v-if="showSticky" @login="login" />
      </transition>
    </div>
  </div>
</template>

<script>
import UserInfo from './userInfo.vue'
import HomeSticky from './HomeSticky.vue'
import { mapState } from 'vuex'
// import导入组件工具等
export default {
  name: 'HomeUserInfo',
  components: {
    UserInfo,
    HomeSticky,
  },
  data() {
    return {
      showSticky: false,
      height: 0,
    }
  },
  // 计算属性
  computed: {
    ...mapState({
      userinfo: (state) => state.user.userInfo,
      loginType: (state) => state.user.loginType,
      isCSSMobile: (state) => state.app.isCSSMobile,
    }),
  },
  watch: {
    userinfo: {
      handler(newVal) {
        if (newVal && newVal.user_id) {
          this.$store.commit('app/SET_IS_MOBILE')
        }
      },
    },
  },
  created() {
    this.checkScroll = this.$utils.throttle(this.checkScroll, 100)
  },
  mounted() {
    // 监听滚动
    document.querySelector('#main-container').addEventListener('scroll', this.checkScroll)
  },
  beforeDestroy() {
    document.querySelector('#main-container').removeEventListener('scroll', this.checkScroll)
  },
  // 组件方法
  methods: {
    login() {
      this.$root.Bus.$emit('sendmsg', {
        event: 'login',
      })
    },
    toggleRole() {
      this.$root.Bus.$emit('toggleRole', { type: 'change' })
    },
    checkScroll(e) {
      if (this.height < 50) {
        this.height = this.$refs.homeUserInfo.offsetTop + 24
      }
      const elTop = (e.target || e.srcElement).scrollTop
      if (elTop > this.height) {
        this.showSticky = true
      } else {
        this.showSticky = false
      }
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.home-user-info {
  margin-top: -16px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  height: 68px;
  z-index: 1;
  box-shadow: 0px 1px 3px 0px #0000001a;
  &--sticky {
    z-index: 12;
  }
  .user-info-container {
    padding: 12px;
  }
  .switch-user {
    width: 32px;
    height: 22px;
    .bg-image('icon_switch');
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .no-login {
    font-size: 14px;
    color: #000;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    span {
      color: #19b05a;
      cursor: pointer;
    }
  }
}
</style>
